import React, { useState, useEffect } from "react";
import packageJson from "../package.json";
import moment from "moment";
import db_realtime from "./Services/Firebase";
import { notification } from "antd";
import { version } from "../package.json";

const buildDateGreaterThan = (latestDate, currentDate) => {
  const momLatestDateTime = moment(latestDate);
  const momCurrentDateTime = moment(currentDate);

  if (momLatestDateTime.isAfter(momCurrentDateTime)) {
    return true;
  } else {
    return false;
  }
};

function withClearCache(Component) {
  function ClearCacheComponent(props) {
    const [isLatestBuildDate, setIsLatestBuildDate] = useState(false);

    let Get_Info_version = async () => {
      try {
        let Value = await db_realtime
          .collection("Version_HDC")
          .where("Updated", "==", false);

        await Value.onSnapshot((val) => {
          val.forEach((doc) => {
            if (doc.data()["versi"] === version) {
              notification.destroy();
            } else {
              notification.open({
                duration: 10,
                message: "Please Refresh Browser",
                description: "Hdc has been updated",
              });
            }
          });
        });
      } catch (error) {
        console.log("error cek Version", error);
      }
    };

    useEffect(() => {
      Get_Info_version();
      fetch("/meta.json")
        .then((response) => response.json())
        .then((meta) => {
          const latestVersionDate = meta.buildDate;
          const currentVersionDate = packageJson.buildDate;

          const shouldForceRefresh = buildDateGreaterThan(
            latestVersionDate,
            currentVersionDate
          );
          if (shouldForceRefresh) {
            setIsLatestBuildDate(false);
            refreshCacheAndReload();
          } else {
            setIsLatestBuildDate(true);
          }
        });
    }, []);

    const refreshCacheAndReload = () => {
      if (caches) {
        // Service worker cache should be cleared with caches.delete()
        caches.keys().then((names) => {
          for (const name of names) {
            caches.delete(name);
          }
        });
      }
      // delete browser cache and hard reload
      window.location.reload(true);
    };

    return (
      <React.Fragment>
        {isLatestBuildDate ? <Component {...props} /> : null}
      </React.Fragment>
    );
  }

  return ClearCacheComponent;
}

export default withClearCache;
